export default __webpack_public_path__ + "src/assets/images/calc_app_standard-269e16f5.png";